import { createFileRoute } from '@tanstack/react-router';
import { PatientDocumentsPageContent } from '@/components/paciente/PacienteClinicalPages';

export const Route = createFileRoute('/pep-vida/_authed/pacientes/$cdPaciente/documentos')({
  component: DocumentosPacientePage,
});

function DocumentosPacientePage() {
  const { cdPaciente } = Route.useParams();
  return <PatientDocumentsPageContent cdPaciente={Number(cdPaciente)} />;
}
